export default "/images/bg-1.jpg?e8182042f6e7e86ffe1a83355916dcd1";